import { useAppSelector } from 'hooks';
import { BillTypes, CurrencySymbol, ShopType } from 'models';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import POS_MANA_LOGO from '../../../assets/images/pos_mana_logo.png';
import POS_ORDER_LOGO from '../../../assets/images/pos_order.png';
import POS_STAFF_LOGO from '../../../assets/images/pos_staff_logo.png';
import TABLE_ORDER_LOGO from '../../../assets/images/table_order_logo.png';
import EmptyCart from '../../../assets/images/empty_cart.png';
import { checkSettingCustom, getCurrencyFormat } from 'utils';
import { useCallback } from 'react';
export interface MainProps {
  billData: BillTypes;
  billLoading: boolean;
}

export function Main(props: MainProps) {
  const { billData, billLoading } = props;
  const { t } = useTranslation();
  const settingsShopCustom = useAppSelector((state) => state.settings.settingsShopCustom);
  const shopsHideSetMenu = [460, 462];
  const shopInfo: any = useAppSelector((state) => state.shop.shopInfo);
  const selectedShop: ShopType = useAppSelector((state) => state.shop.shopInfo);
  // 31/10/2025, handle dynamic shop should show/hide set menu
  const handleCheckShopShouldHideMenuNew = useCallback(() => {
    const findSettingShowSetMenuWebMenu = settingsShopCustom.find(
      (item) => item.name == 'show_set_menu_web_menu'
    );
    // if shop food always return false
    if (shopInfo.food == 1) return false;
    return Boolean(
      findSettingShowSetMenuWebMenu?.active &&
      JSON.parse(String(findSettingShowSetMenuWebMenu.app_name || '[]')).includes(9)
    );
  }, [settingsShopCustom.length, shopInfo.food]);
  const checkShopShowNominationTimes = handleCheckShopShouldHideMenuNew();
  const priceFormat = (price: number) => {
    const format = getCurrencyFormat(selectedShop.currency as CurrencySymbol);
    const { locale, options } = format;
    return price.toLocaleString(locale, options as any);
  };

  const formatDate = (date: string) => {
    if (!date) {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();
      return `${year}年${month}月${day}日`;
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    return `${year}年${month}月${day}日`;
  };
  const formatTime = (time: string) => {
    if (!time) {
      const d = new Date();
      const hour = d.getHours();
      const minute = d.getMinutes();
      return `${hour}時${minute}分`;
    }
    const d = new Date(time);
    const hour = d.getHours();
    const minute = d.getMinutes();
    return `${hour}時${minute}分`;
  };

  const table = [
    { title: 'テーブル番号', content: billData?.tables?.name || 'FREE' },
    { title: '日付', content: formatDate(billData?.created_at) },
    { title: '時間', content: formatTime(billData?.created_at) },
    { title: '伝票番号', content: billData?.code },
    ...(shopInfo?.id === 468
      ? []
      : [
          { title: '顧客名', content: billData?.customer?.name || 'FREE' },
          { title: '指名', content: billData?.service_fee, value: 'host' },
        ]),
  ];
  const getNumberOfNomination = () => {
    const numberOfNomination = billData.service_fee?.filter((i) => i.type === 1) || [];
    return numberOfNomination.length || 0;
  };
  const tableInfo = [
    {
      title: 'テーブル',
      content: billData.tables?.name || '',
    },
    {
      title: '日付',
      content: moment(billData?.created_at).format('YYYY/MM/DD'),
    },
    {
      title: '伝票コード',
      content: billData?.code || '-',
    },
    ...(checkShopShowNominationTimes
      ? [
          {
            title: '指名本数',
            content: getNumberOfNomination(),
          },
        ]
      : []),
  ];

  const __renderOrderByApp = (app_name: number) => {
    switch (app_name) {
      case 2:
        return POS_ORDER_LOGO;
      case 3:
        return POS_MANA_LOGO;
      case 5:
        return POS_STAFF_LOGO;
      case 7:
        return TABLE_ORDER_LOGO;
      default:
        return POS_MANA_LOGO;
    }
  };
  const isShowOrderHistoryPage = checkSettingCustom({
    settingsShopCustom,
    check: 'hide_history_order_web_menu',
  });

  return (
    <div className="flex flex-1 flex-col bg-white">
      {/* OLD BILL LAYOUT */}
      {/* {table.map((item, idx) => (
        <div key={idx} className="w-full flex px-4 border-b border-dashed py-8  ">
          <span className="text-14 flex items-center flex-1 font-regular text-8C8C8C ">
            {item.title}
          </span>

          {item.value === 'host' ? (
            <div className="flex flex-1 flex-col space-y-2 text-18 font-medium">
              {item.content.length > 0 ? (
                item.content.map((host, index) => (
                  <span key={index}>{host.user_of_shop?.nick_name || 'FREE'}</span>
                ))
              ) : (
                <span>FREE</span>
              )}
            </div>
          ) : (
            <span className="flex flex-1  text-18 font-medium">{item.content as string}</span>
          )}
        </div>
      ))} */}
      {/* 29/7/2025 NEW BILL LAYOUT */}
      <div className="table-info w-full flex items-center py-3 border-b border-border_primary">
        {tableInfo.map((item, index) => (
          <div
            key={index}
            className={`${
              checkShopShowNominationTimes
                ? 'first:w-[18%] last:w-[20%] [&:nth-child(2)]:w-1/4 w-full'
                : 'w-1/3'
            } whitespace-nowrap text-center border-r last:border-r-0 border-border_primary px-2`}
          >
            <span className="text-[#939393]">{item.title}</span>
            <p className="!font-noto-sans-bold text-brown_dark font-[500]">{item.content}</p>
          </div>
        ))}
      </div>
      {!isShowOrderHistoryPage && (
        <div>
          <h3 className="font-noto-sans-bold text-brown_dark text-base p-3">
            {t('ORDER_HISTORY')}
          </h3>
          <div className="w-full overflow-auto">
            {billData.bill_detail?.length && !billLoading ? (
              <table className="order-history-table w-full">
                <thead>
                  <tr className="w-full">
                    <th>{t('MERCHANDISE')}</th>
                    {/* <th>{t('ORDERER')}</th> */}
                    <th>{t('TIME')}</th>
                    <th>{t('AMOUNT')}</th>
                  </tr>
                </thead>
                <tbody>
                  {[...billData.bill_detail]
                    .sort((a, b) => moment(b?.created_at).diff(moment(a?.created_at)))
                    .map((item) => (
                      <tr key={item.id}>
                        <td>{item.name || ''}</td>
                        {/* <td>{billData.creator.nick_name || ''}</td> */}
                        <td>{moment(item.created_at).format('HH:mm')}</td>
                        {/* <td className="align-middle">
                      <img
                        src={__renderOrderByApp(item.app_name)}
                        alt=""
                        className="inline-block w-12 h-w-12 align-middle"
                      />
                    </td> */}
                        <td>{priceFormat(item.amount)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : billLoading ? (
              <>loading</>
            ) : (
              <div className="w-full h-full">
                <table className="order-history-table w-full">
                  <thead>
                    <tr>
                      <th>{t('MERCHANDISE')}</th>
                      {/* <th>{t('ORDERER')}</th> */}
                      <th>{t('TIME')}</th>
                      <th>{t('AMOUNT')}</th>
                    </tr>
                  </thead>
                </table>
                <div className="mt-[40px] flex flex-col items-center justify-center">
                  <img src={EmptyCart} alt="" className="w-[100px] h-[100px] aspect-square" />
                  <div className="mt-[17px] text-[#939393] text-base text-center">
                    <p>{t('NO_PRODUCT')}</p>
                    <p>{t('PLEASE_ORDER_THE_PRODUCT')}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
